<script setup lang="ts">
/***
 * template to show array of POS
 */
import { useI18n } from 'vue-i18n';

import type { PaginatedDataTableCellProps } from '@/components/paginated-datatable/templates/templateTypes';
import { ConnectedByV1Dto, type SimpleConnectV1Dto } from '@/openapi';
import { navigationItems } from '@/router/navigation';
const { t } = useI18n();
const customersIcon = `${navigationItems?.find((a) => a.name === 'customers')?.icon ?? 'mdi mdi-factory'} sey-icon mr-1`;
const posIcon = `${navigationItems?.find((a) => a.name === 'pointofsales')?.icon ?? 'mdi mdi-point-of-sale'} sey-icon mr-1`;
const connectionType = ConnectedByV1Dto['connectionType'];
const props = defineProps<PaginatedDataTableCellProps>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <div v-for="arrayValue in props.cell as Array<SimpleConnectV1Dto>" :key="arrayValue.id">
      <div>
        <span :class="customersIcon"> </span>
        <RouterLink class="a-inline" :to="`/customers/${arrayValue.id}`">{{
          arrayValue.name
        }}</RouterLink>
      </div>
      <div v-for="connValue in arrayValue.connectedBy" :key="connValue.id">
        <div v-if="connValue.connectionType === connectionType['POINT_OF_SALE']">
          <span :class="posIcon"> </span>
          <RouterLink class="a-inline" :to="`/pointofsales/${connValue.id}`">{{
            t('labels.connectedBy', { source: t('labels.pointOfSales') })
          }}</RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>
